/**
 * Semantic typography classes — five sizes (`text-caption` … `text-display`), body
 * vs title leading, and uppercase section labels (`type-overline` / `type-lone-title`).
 */
export const typeScale = {
  caption: "text-caption",
  label: "text-label",
  body: "text-body",
  title: "text-title",
  display: "text-display",
} as const;

export const typeLeading = {
  body: "leading-body",
  title: "leading-title",
} as const;

/** Standard uppercase section label (size 2, tight title leading). */
export const typeOverline = "type-overline";

/** Standalone uppercase heading — same size as overline, +25% letter-spacing. */
export const typeLoneTitle = "type-lone-title";

/** Body copy at scale step 3 with normal row height. */
export const typeBody = `${typeScale.body} ${typeLeading.body}`;

/** Display / page title at scale step 4–5 with tight title leading. */
export const typePageTitle = `${typeScale.title} ${typeLeading.title} font-semibold`;
